/**
 * grid related operations.
 */
angular.module("AppCtrl.grid.service",[]).
	/**
	 * closes the filter and makes the grid wider.
	 * 	default classes:
	 * 	i)   jv-filter: Dom element containing the full filter. You can provide your own class too.
	 * 	ii)	 jv-filterOpener: Dom element when clicked will open the filter. You can provide your own class too.
	 *  iii) jv-grid: Grid on the right side which will wider or shorter.
	 */
	factory('closeFilter', function(){
		// Assuming we have modernizer available and we want to use css3, fallback to javascript.
		return function( jqelementFilter, jqelementOpener ){
			jqelementFilter = (typeof jqelementFilter == "undefined")? ".jv-filter": jqelementFilter;
			jqelementOpener = (typeof jqelementOpener == "undefined")? ".jv-filterOpener": jqelementOpener;
			//close filter
			if(typeof Modernizr != "undefined" && Modernizr.csstransitions){
				$(jqelementFilter).addClass("jv-filter-close");
				$(jqelementOpener).addClass("jv-filterOpener-open");
				$(".jv-grid").addClass("jv-grid-long");
			}else{
				// fallback
				$(jqelementFilter).animate({
					"margin-left": "-226px"
				});
				$(jqelementOpener).animate({
					"margin-left": "226px"
				});
				$(".jv-grid").animate({
					"margin-left": "50px",
					"width": "940px"
				}, 550);
			}
		}
	}).
	/**
	 * opens the filter and makes the grid wider.
	 * 	default classes:
	 * 	i)   jv-filter: Dom element containing the full filter. You can provide your own class too.
	 * 	ii)	 jv-filterOpener: Dom element when clicked will open the filter. You can provide your own class too.
	 *  iii) jv-grid: Grid on the right side which will wider or shorter.
	 */
	factory('openFilter', function(){
		// Assuming we have modernizer available and we want to use css3, fallback to javascript.
		return function( jqelementFilter, jqelementOpener ){
			jqelementFilter = (typeof jqelementFilter == "undefined")? ".jv-filter": jqelementFilter;
			jqelementOpener = (typeof jqelementOpener == "undefined")? ".jv-filterOpener": jqelementOpener;
			if(typeof Modernizr != "undefined" && Modernizr.csstransitions){
				$(jqelementFilter).removeClass("jv-filter-close");
				$(jqelementOpener).removeClass("jv-filterOpener-open");
				$(".jv-grid").removeClass("jv-grid-long");	
			}else{
				$(".jv-grid").animate({
					"margin-left": "220px",
					"width": "770px"
				},300);
				// fallback
				$(jqelementFilter).animate({
					"margin-left": "0px"
				});
				$(jqelementOpener).animate({
					"margin-left": "-50px"
				});
			}
		}
	});

angular.module("AppCtrl.web.service",[]).
	/**
	 * Used for getting campaigns based on the value of the filters.
	 * @param {Object} $http
	 */
	factory('makeAjaxCall',['$http', '$rootScope', function($http, $rootScope){
		/** 
		 * IMPORTANT
		 *	@param: "args" must have following properties.
		 * "url":(required) the url where the ajax call be posted.
		 * "ajaxtype":(required) for analtyics purpose, it should be any unique name.
		 * "requestType":(optional) GET,POST, PUT, DELETE. By default it does a GET
		 * 
		 * NOTE: this method uses the jquery ajax call because the backend needs a query params like this
		 * 
		 * 		key1 value1
		 * 		key1 value2
		 * 
		 * by serializing an array with angular doesn't support. Therefor everytime you call something you have to do $scope.$apply() to effect the changes in the UI. 
		 * https://github.com/angular/angular.js/pull/1364
		 * 
		 */
		return function( args ){
			if(typeof args == 'undefined' || typeof args.url == "undefined" || typeof args.ajaxtype == "undefined"){
				try{
					console.log("One or more required fields are not present.")
				}catch(e){ }
				return;
			}
			var _httpObject = { };
			_httpObject.headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'};
			var _requestParam = "params";
			//_httpObject.type = !!args.requestType ? args.requestType: 'GET';
			_httpObject.method = !!args.requestType ? args.requestType: 'GET';
			if( _httpObject.method == "POST"){
				_requestParam = "data";
			}

			//_httpObject[_requestParam] = $.param(args);
			//_httpObject.contentType = args.contentType ? args.contentType : 'application/x-www-form-urlencoded';
			//_httpObject.traditional = true;
			_httpObject.url = args.url;
			//analytics
			if(typeof _gaq != "undefined"){
				_gaq.push(['_trackEvent', JV.PAGE_TYPE, args.ajaxtype, _jvselfUser.companyEId]);
			}
			//delete the properties which are not required for the post.
			var removeProperties = ["url","requestType","ajaxtype","forceAsPostData"];
			for( var i=0; i< removeProperties.length; i++){
				delete args[removeProperties[i]];	
			}
			
			angular.forEach(args, function(value, key){
		        if(value==undefined){
		            delete args[key];
		        }
		    })
		    
			if( _httpObject.method == "GET"){
				if(_httpObject.url.indexOf('?') != -1){
					_httpObject.url = _httpObject.url+ "&"+$.param(args, true) 
				}else{
					_httpObject.url = _httpObject.url+ "?"+$.param(args, true)
				}
				_httpObject.url += "&"+new Date().getTime();
			}else{
				_httpObject[_requestParam] = $.param(args, true);	
			}
			
			//var promise = $.ajax( _httpObject );
			var promise = $http(_httpObject);
			return promise;
			 
//			console.log(promise);
//			return promise;
			//VA: Angular doesn't support multiple array values so it has to replaced with the jquery ajax request.
			//return $http(_httpObject);
			
		}
	}]);

var  jvservice= angular.module("AppCtrl.jobvite.service",["AppCtrl.grid.service", "AppCtrl.web.service"]);